import React from 'react';
import PropTypes from 'prop-types';
import { VotingClosed } from '../../components/VotingClosed';
import { LoginWithPassword } from '../../components/LoginWithPassword';
import { SignUpWithPassword } from '../../components/SignUpWithPassword';
import { LiveSetlist } from '../../components/LiveSetlist';

// Hardcoded flag - set to true when voting is closed
const VOTING_IS_CLOSED = true;

export const Auth = ({ initialView = 'login' }) => {
  const [isLogin, setIsLogin] = React.useState(initialView === 'login');

  const toggleAuth = () => {
    setIsLogin(!isLogin);
  };

  // Show voting closed message when voting is closed
  if (VOTING_IS_CLOSED) {
    return <VotingClosed />;
  }

  // Show normal auth flow when voting is open
  return (
    <>
      <LiveSetlist />
      {isLogin ? (
        <LoginWithPassword onSwitch={toggleAuth} />
      ) : (
        <SignUpWithPassword onSwitch={toggleAuth} />
      )}
    </>
  );
};

Auth.propTypes = {
  initialView: PropTypes.oneOf(['login', 'signup'])
};
